import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  CLUB_EVENT_CHANGE_STATUS,
  CLUB_EVENT_CREATE,
  CLUB_EVENT_DELETE,
  CLUB_EVENT_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const clubEventCreate = createAsyncThunk(
  CLUB_EVENT_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.CLUB_EVENT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.clubEventCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const clubEventList = createAsyncThunk(
  CLUB_EVENT_LIST,
  async (params: PayloadCreatorParams<`${typeof API.CLUB_EVENT}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.clubEventList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const clubEventDelete = createAsyncThunk(
  CLUB_EVENT_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.CLUB_EVENT}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.clubEventDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const clubEventChangeStatus = createAsyncThunk(
  CLUB_EVENT_CHANGE_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.CLUB_EVENT_STATUS}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.clubEventChangeStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const clubEventListClear = createAction(`${CLUB_EVENT_LIST}/clear`)
